import Button from "components/atoms/Button";
import React from "react";
import { monthConverter } from "utils/common";
import { formatParasite } from "utils/parasite";
import { useHistory } from "react-router-dom";

const TableComponent = ({
  reportsData,
  tableRef,
  reportInfo,
  currentLevel,
}) => {
  const history = useHistory();

  let levelName = "";

  if (currentLevel === "national") {
    levelName = "Nasional";
  } else if (currentLevel === "province") {
    levelName = "Provinsi";
  } else if (currentLevel === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Lab";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.lab;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  const onViewDetailData = (id) => {
    history.push(`/detail-register-malaria-1-from-lpkl34/${id}`);
  };

  return (
    <div
      className="table-responsive"
      style={{ backgroundColor: "#fff" }}
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingBottom: 0 }}>
            <h3>
              SISMAL v3, Rekap Agregat Data Surveilans {formatParasite("Knowlesi")} -
              Lab
            </h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {periodeName === "Bulanan" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Lab</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.lab ? "Semua Lab" : result}
          </th>
        </tr>
      </table>
      <table>
        <thead>
          <tr>
            <th>Fasyankes Pengirim</th>
            <th>
              Jumlah Sediaan Apusan Darah (SAD) yang Dikirim Untuk Konfirmasi
            </th>
            <th>Jumlah Sediaan Apusan Darah (SAD) Diterima</th>
            <th>Jumlah Dried Blood Spot (DBS) yang Dikirim Untuk Konfirmasi</th>
            <th>Jumlah Dried Blood Spot (DBS) Diterima</th>
            <th>
              Jumlah Whole Blood EDTA (WB) yang Dikirim Untuk Konfirmasi
            </th>
            <th>Jumlah Whole Blood EDTA (WB) Diterima</th>
            <th>
              Jumlah Sediaan Apusan Darah (SAD) yang Memenuhi Syarat untuk Dapat
              Diperiksa PCR
            </th>
            <th>
              Jumlah Dried Blood Spot (DBS) yang Memenuhi Syarat untuk Dapat
              Diperiksa PCR
            </th>
            <th>
              Jumlah Whole Blood EDTA (WB) yang Memenuhi Syarat untuk Dapat
              Diperiksa PCR
            </th>
            <th>Jumlah Sampel PCR Positif {formatParasite("Knowlesi")}</th>
            <th>Jumlah Sampel PCR Negatif {formatParasite("Knowlesi")}</th>
          </tr>
        </thead>
        <tbody>
          {reportsData?.length > 0 ? (
            reportsData?.map((item, index) => (
              <tr key={index}>
                <td>{item?.fasyankes_name}</td>
                <td>{item?.total_sad_send}</td>
                <td>{item?.total_sad_received}</td>
                <td>{item?.total_dbs_send}</td>
                <td>{item?.total_dbs_received}</td>
                <td>{item?.total_wb_send}</td>
                <td>{item?.total_wb_received}</td>
                <td>{item?.total_sad_pcr}</td>
                <td>{item?.total_dbs_pcr}</td>
                <td>{item?.total_wb_pcr}</td>
                <td>{item?.total_samples_positive_knowlesi}</td>
                <td>{item?.total_samples_negative_knowlesi}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={73}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
